/**
 * Human-readable API error text. Full detail + traceback only when the server
 * reports DEBUG_MODE (see /health and /api/public-settings).
 */
export function formatApiError(error, serverDebug) {
  const d = error.response?.data;
  const status = error.response?.status;

  if (serverDebug && d) {
    const parts = [];
    if (d.detail !== undefined && d.detail !== null) {
      parts.push(
        typeof d.detail === "string" ? d.detail : JSON.stringify(d.detail, null, 2),
      );
    }
    if (Array.isArray(d.traceback)) {
      parts.push(d.traceback.join("\n"));
    }
    if (parts.length) {
      return parts.join("\n\n");
    }
  }

  if (d?.detail != null) {
    if (typeof d.detail === "string") {
      return d.detail;
    }
    if (typeof d.detail === "object" && d.detail.error) {
      return String(d.detail.error);
    }
    return "Request failed";
  }

  if (status === 500 && !serverDebug) {
    return "Something went wrong. Try again later.";
  }

  return error.message || "Request failed";
}
